<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-row items-center">
          <div class="flex flex-row w-full">
            <div>
              <span style="font-weight:bold;">{{proficiencyList.length}} Proficiencies Found </span>
              <br />
              <span style="font-size:small"> * incidates a result with comments</span>
            </div>
          </div>

          <div class="flex flex-row items-center justify-center">
            <div>
              <button type="button" *ngIf="!labService.readonly" mat-raised-button color="warn" (click)="addNewTest()">
                <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
                Add Test
              </button>
            </div>
            <mat-form-field Style="padding-right:20px; padding-left: 20px;">
              <mat-label>View</mat-label>
              <mat-select [(value)]="view" (selectionChange)="selectView()">
                <mat-option value="All">All</mat-option>
                <mat-option value="Failed">Failed</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field Style="padding-right:20px">
              <mat-label>Select Year</mat-label>
              <mat-select [(value)]="year" (selectionChange)="selectYear()">
                <mat-option *ngFor="let yrs of yearsList" [value]="yrs">{{yrs}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
      'bg-gray-600': sharedService.userTheme === 'dark',
      'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col" *ngIf="proficiencyList.length !== 0">
          <div class="flex flex-row">
            <mat-form-field class="w-1/4">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full">
                <ng-container matColumnDef="specialty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Specialty</th>
                  <td mat-cell *matCellDef="let prof">{{prof.specialty}}</td>
                </ng-container>
                <ng-container matColumnDef="evaluator">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Eval</th>
                  <td mat-cell *matCellDef="let prof">{{prof.evaluator}}</td>
                </ng-container>
                <ng-container matColumnDef="subSpecialty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub-Spec</th>
                  <td mat-cell *matCellDef="let prof">{{prof.subSpecialty}}</td>
                </ng-container>
                <ng-container matColumnDef="testCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
                  <td mat-cell *matCellDef="let prof">{{prof.testCode}}</td>
                </ng-container>
                <ng-container matColumnDef="analyte">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Analyte</th>
                  <td mat-cell *matCellDef="let prof">{{prof.analyte}}</td>
                </ng-container>
                <ng-container matColumnDef="testId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Test Id</th>
                  <td mat-cell *matCellDef="let prof">{{prof.testId}}</td>
                </ng-container>

                <ng-container matColumnDef="yrResult0_1">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{yearNum - 1}} (1)</th>
                  <td mat-cell *matCellDef="let prof">
                    <button mat-icon-button *ngIf="prof.yrResult0_1 == null" matTooltip="Add New"
                      (click)="addNewResult(yearNum - 1, 1, prof)" [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="prof.yrResult0_1 != null" matTooltip="Edit"
                      (click)="editResult(yearNum - 1, 1, prof)" [matTooltipShowDelay]="750"
                      [style.color]="getColor(prof.yrResult0_1.ptPercent)">
                      {{prof.yrResult0_1.comments != null? '*' : ''}}{{prof.yrResult0_1.ptPercent}}
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="yrResult0_2">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{yearNum - 1}} (2)</th>
                  <td mat-cell *matCellDef="let prof">
                    <button mat-icon-button *ngIf="prof.yrResult0_2 == null" matTooltip="Add New"
                      (click)="addNewResult(yearNum - 1, 2, prof)" [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="prof.yrResult0_2 != null" matTooltip="Edit"
                      (click)="editResult(yearNum - 1, 2, prof)" [matTooltipShowDelay]="750"
                      [style.color]="getColor(prof.yrResult0_2.ptPercent)">
                      {{prof.yrResult0_2.comments != null? '*' : ''}}{{prof.yrResult0_2.ptPercent}}
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="yrResult0_3">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{yearNum - 1}} (3)</th>
                  <td mat-cell *matCellDef="let prof">
                    <button mat-icon-button *ngIf="prof.yrResult0_3 == null" matTooltip="Add New"
                      (click)="addNewResult(yearNum - 1, 3, prof)" [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="prof.yrResult0_3 != null" matTooltip="Edit"
                      (click)="editResult(yearNum - 1, 3, prof)" [matTooltipShowDelay]="750"
                      [style.color]="getColor(prof.yrResult0_3.ptPercent)">
                      {{prof.yrResult0_3.comments != null? '*' : ''}}{{prof.yrResult0_3.ptPercent}}
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="yrResult1_1">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{yearNum}} (1)</th>
                  <td mat-cell *matCellDef="let prof">
                    <button mat-icon-button *ngIf="prof.yrResult1_1 == null" matTooltip="Add New"
                      (click)="addNewResult(yearNum, 1, prof)" [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="prof.yrResult1_1 != null" matTooltip="Edit"
                      (click)="editResult(yearNum, 1, prof)" [matTooltipShowDelay]="750"
                      [style.color]="getColor(prof.yrResult1_1.ptPercent)">
                      {{prof.yrResult1_1.comments != null? '*' : ''}}{{prof.yrResult1_1.ptPercent}}
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="yrResult1_2">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{yearNum}} (2)</th>
                  <td mat-cell *matCellDef="let prof">
                    <button mat-icon-button *ngIf="prof.yrResult1_2 == null" matTooltip="Add New"
                      (click)="addNewResult(yearNum, 2, prof)" [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="prof.yrResult1_2 != null" matTooltip="Edit"
                      (click)="editResult(yearNum, 2, prof)" [matTooltipShowDelay]="750"
                      [style.color]="getColor(prof.yrResult1_2.ptPercent)">
                      {{prof.yrResult1_2.comments != null? '*' : ''}}{{prof.yrResult1_2.ptPercent}}
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="yrResult1_3">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{yearNum}} (3)</th>
                  <td mat-cell *matCellDef="let prof">
                    <button mat-icon-button *ngIf="prof.yrResult1_3 == null" matTooltip="Add New"
                      (click)="addNewResult(yearNum, 3, prof)" [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="prof.yrResult1_3 != null" matTooltip="Edit"
                      (click)="editResult(yearNum, 3, prof)" [matTooltipShowDelay]="750"
                      [style.color]="getColor(prof.yrResult1_3.ptPercent)">
                      {{prof.yrResult1_3.comments != null? '*' : ''}}{{prof.yrResult1_3.ptPercent}}
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>

        </div>

      </mat-card-content>

    </mat-card>
  </div>
</div>